<div>{{ getPhaseNote() }}</div>
